import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


function DeleteFarmer({showConfirmationModal, toggle, message}) {

    return(
        <>
            <Modal isOpen={showConfirmationModal} toggle={toggle} centered={true}>
                <ModalHeader toggle={toggle}>Confirm Your Action</ModalHeader>
                <ModalBody>
                    {message}<br/>
                    <b>This cannot be UNDONE</b>!
                </ModalBody>
                <ModalFooter>
                    <Button color="danger">Yes, Confirm</Button>
                    {' '}
                    <Button color="primary" onClick={toggle}>No</Button>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default DeleteFarmer;

